















import { toRefs, getCurrentInstance, ComponentInternalInstance, defineComponent, computed } from '@vue/composition-api';
export default defineComponent({
  name: 'MultiSelect',
  props: {
    data: {
      required: true,
      type: Array,
    },
  },
  setup(props, context) {
    const { data: items } = toRefs(props);
    const currComponent = getCurrentInstance() as ComponentInternalInstance;
    const vm = currComponent.proxy;
    const noSelected = computed(() => vm.$store.state.drawer.coSpaceNoSelected);
    return {
      noSelected,
      items,
    };
  },
});
